import { render, staticRenderFns } from "./DetailBySkill.vue?vue&type=template&id=410ed491&"
import script from "./DetailBySkill.vue?vue&type=script&lang=js&"
export * from "./DetailBySkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports